import axios from "./axios";

export const itemListsApi = {
  // Get all item lists
  getItemLists: async (params = {}) => {
    return axios.get("/item_lists", { params });
  },

  // Get a single item list by ID
  getItemList: async (id) => {
    return axios.get(`/item_lists/${id}`);
  },

  // Create a new item list
  createItemList: async (data) => {
    return axios.post("/item_lists", {
      item_list: data,
    });
  },

  // Update an existing item list
  updateItemList: async (id, data) => {
    return axios.put(`/item_lists/${id}`, {
      item_list: data,
    });
  },

  // Delete an item list
  deleteItemList: async (id) => {
    return axios.delete(`/item_lists/${id}`);
  },

  // Approve an item list
  approveItemList: async (id, comment = "") => {
    return axios.post(`/item_lists/${id}/approve`, {
      approval_comment: comment,
    });
  },

  // Reject an item list
  rejectItemList: async (id, comment = "") => {
    return axios.post(`/item_lists/${id}/reject`, {
      approval_comment: comment,
    });
  },

  // Submit item list for approval
  submitItemListForApproval: async (id) => {
    return axios.post(`/item_lists/${id}/submit_for_approval`);
  },

  markItemListInvoicedManually: async (id, comment = "") => {
    return axios.post(`/item_lists/${id}/mark_invoiced_manually`, { comment });
  },

  mergeItemListsToOrder: async (payload) => {
    return axios.post(`/item_lists/merge_to_order`, payload);
  },

  // Add item to item list
  addItemToList: async (itemListId, data) => {
    return axios.post(`/item_lists/${itemListId}/item_list_items`, {
      item_list_item: data,
    });
  },

  // Update item in item list
  updateItemInList: async (itemListId, itemId, data) => {
    return axios.put(`/item_lists/${itemListId}/item_list_items/${itemId}`, {
      item_list_item: data,
    });
  },

  // Remove item from item list
  removeItemFromList: async (itemListId, itemId) => {
    return axios.delete(`/item_lists/${itemListId}/item_list_items/${itemId}`);
  },

  // Get item lists for a work order
  getWorkOrderItemLists: async (workOrderId, params = {}) => {
    return axios.get("/item_lists", {
      params: {
        work_order_id: workOrderId,
        ...params
      }
    });
  },

  // Get item lists for a report
  getReportItemLists: async (reportId, params = {}) => {
    return axios.get("/item_lists", {
      params: {
        report_id: reportId,
        ...params
      }
    });
  },
};
